import React, { useState } from "react";
import "./home.css";
import Profile from "../profile/Profile";
import Top from "../top/Top";
import Menu from "../menu/Menu";
import Bottom from "../bottom/Bottom";

export default function Home({ user }) {
  const [item, setItem] = useState(0);
  const [filter, setFilter] = useState("All");

  return (
    <div className="home">
      <div className="home-left">
        <Profile user={user} />
      </div>
      <div className="home-right">
        <Top item={item} user={user} />
        <Menu
          item={item}
          setItem={setItem}
          user={user}
          filter={filter}
          setFilter={setFilter}
        />
        <Bottom user={user} filter={filter} />
      </div>
    </div>
  );
}
